import React from 'react';

const Error = ({ error }) => {
  return (
    <div className='error'>
      Error: {error}
    </div>
  );
}

export default Error;
